module.exports = {
        srcSet: __webpack_public_path__ + "amenities_uber_eats-173-9f7b7e2782355b8e.digested.png"+" 173w",
        images: [{path: __webpack_public_path__ + "amenities_uber_eats-173-9f7b7e2782355b8e.digested.png",width: 173,height: 132}],
        src: __webpack_public_path__ + "amenities_uber_eats-173-9f7b7e2782355b8e.digested.png",
        toString: function(){return __webpack_public_path__ + "amenities_uber_eats-173-9f7b7e2782355b8e.digested.png"},
        
        width: 173,
        height: 132
      }